import Vue from 'vue';
import store from '../store/index.js';
import ContentComponent from '../components/adjustable-content/adjustable-content-component.vue';

DM.Module.Content = ((DM) => {
    const SELECTOR = '.js-content';
    const ELEMENT = document.querySelector(SELECTOR);

    const CONTENT_COMPONENTS = {
        0: 'dm-products-banner-component',
        1: 'dm-article-component',
        2: 'dm-thumb-article-component',
        3: 'dm-heading-component',
        4: 'dm-top-products-component',
        5: 'dm-banner-component',
        6: 'dm-scrollable-banners-component'
    };

    class Content {
        constructor(element) {
            const forcePreviewParam = element.dataset.forcePreview || '';
            DM.Service.Content.getContent(forcePreviewParam).then((content) => {
                content = content.map(contentItem => {
                    const componentsName = { type: CONTENT_COMPONENTS[contentItem.type] };
                    return Object.assign({}, contentItem, componentsName);
                });
                this.createComponent(element, content);
            }).catch((msg) => {
                throw (msg.statusText + ' mainpage content. Problem fetching data.');
            });
        }

        createComponent(element, content) {
            return new Vue({
                name: 'dm-home-adjustable-content',
                el: element,
                store,
                components: {
                    'dm-adjustable-content': ContentComponent
                },
                template: '<dm-adjustable-content :contentItems="contentItems" />',
                data: {
                    contentItems: content
                },
            });
        }
    }
    if (ELEMENT) {
        new Content(ELEMENT);
    }
})(window.DM);
